import React from "react";
import { faqItems } from "./landingContent";

export default function LandingFaq() {
  return (
    <section className="hr-landing-section hr-landing-section--muted" aria-labelledby="hr-landing-faq-title">
      <div className="home-page__container home-page__container--narrow">
        <header className="hr-landing-section__head">
          <h2 id="hr-landing-faq-title" className="hr-landing-section__title">
            שאלות נפוצות
          </h2>
        </header>
        <div className="hr-landing-faq">
          {faqItems.map((item, i) => (
            <details key={i} className="hr-landing-faq__item">
              <summary className="hr-landing-faq__q">{item.q}</summary>
              <p className="hr-landing-faq__a">{item.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
